import { Dispatch } from 'redux';
import { ClientRepositoryImpl } from '../../../data/repositories/client-repository-impl';
import { ClientUsecaseImpl } from '../../../domain/usecases/client-usecase';
import {
  CLIENT_LOAD_FAILURE,
  CLIENT_LOAD_REQUEST,
  CLIENT_LOAD_SUCCESS,
  CreateClientRequest
} from '../types/client-types';

import {
  CLIENTS_LOAD_FAILURE,
  CLIENTS_LOAD_REQUEST,
  CLIENTS_LOAD_SUCCESS
} from '../types/clients-types';

import {
  PARTNERS_LOAD_FAILURE,
  PARTNERS_LOAD_REQUEST,
  PARTNERS_LOAD_SUCCESS
} from '../../../../three-pl-partners/presentation/redux/types/partners-type';

import {
  APIKEY_LOAD_FAILURE,
  APIKEY_LOAD_REQUEST,
  APIKEY_LOAD_SUCCESS,
  APIKEY_RESET_REQUEST
} from '../types/apikey-types';

import {
  LOADING_FAILURE,
  LOADING_REQUEST,
  LOADING_SUCCESS
} from '../../../../../core/redux/types/loading-types';
import { UPLOAD_FAILURE, UPLOAD_REQUEST, UPLOAD_SUCCESS } from '../types/upload-types';

import {
  SMS_NOTIFICATIONS_DISABLE_REQUEST,
  SMS_NOTIFICATIONS_ENABLE_REQUEST,
  SMS_PROVIDER_UPDATE_REQUEST
} from '../types/sms-provider-types';

import {
  OTP_SMS_NOTIFICATIONS_DISABLE_REQUEST,
  OTP_SMS_NOTIFICATIONS_ENABLE_REQUEST
} from '../types/otp-provider-types';

export const createClientAction = (createClientRequest: CreateClientRequest, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: CLIENT_LOAD_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.CreateClient(createClientRequest);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.history.push(`/clients/${result.id}/view`);
    } catch (error) {
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};

export const editClientAction = (client_id: string, name: string, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.EditClient(client_id, name);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
      props.handleClose();
    } catch (error) {
      dispatch({ type: LOADING_FAILURE, error });
    }
  };
};

export const getClients = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: CLIENTS_LOAD_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GetClients();

      dispatch({ type: CLIENTS_LOAD_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: CLIENTS_LOAD_FAILURE, error });
    }
  };
};

export const getClient = (client_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: CLIENT_LOAD_REQUEST });
    dispatch({ type: APIKEY_RESET_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GetClient(client_id);
      const clients = await clientUsecase.GetClients();

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: CLIENTS_LOAD_SUCCESS, payload: clients });
    } catch (error) {
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};

export const getApiKeyAction = (client_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: APIKEY_LOAD_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GetApiKey(client_id);

      dispatch({ type: APIKEY_LOAD_SUCCESS, payload: result.keys });
    } catch (error) {
      dispatch({ type: APIKEY_LOAD_FAILURE, error });
    }
  };
};

export const getSMSApiKeys = (client_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: APIKEY_LOAD_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);
      const result = await clientUsecase.GetSMSAPIKeys(client_id);

      dispatch({ type: APIKEY_LOAD_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: APIKEY_LOAD_FAILURE, error });
    }
  };
};

export const createSuperUserAction = (
  client_id: string,
  firstname: string,
  lastname: string,
  email: string,
  mobile_no: string
) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.CreateSuperUser(
        client_id,
        firstname,
        lastname,
        email,
        mobile_no
      );

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
    } catch (error) {
      dispatch({ type: LOADING_FAILURE, error });
    }
  };
};

export const editSuperUserAction = (
  client_id: string,
  user_id: string,
  firstname: string,
  lastname: string,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.EditSuperUser(client_id, user_id, firstname, lastname);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
      props.handleClose();
    } catch (error) {
      dispatch({ type: LOADING_FAILURE, error });
    }
  };
};

export const uploadLogoAction = (client_id: string, file: any, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: UPLOAD_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.UploadLogo(client_id, file);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: UPLOAD_SUCCESS });
      props.uploadSuccess();
    } catch (error) {
      dispatch({ type: UPLOAD_FAILURE, error });
    }
  };
};

export const grantServiceRightsAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantServicePermissions(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Service access enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const revokeServiceRightsAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.RevokeServicePermissions(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Service access disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const grantQRTypingRightsAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantQRTypingPermissions(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'QR typing access enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const revokeQRTypingRightsAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.RevokeQRTypingPermissions(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'QR typing access disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const grantSecondaryDriverRightsAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantSecondaryDriverPermissions(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'QR typing access enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const revokeSecondaryDriverRightsAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.RevokeSecondaryDriverPermissions(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'QR typing access disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const grantWalletFeatureAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantWalletFeature(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Wallet Feature enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const grantWalletFeatureInitialAction = (
  client_id: string,
  public_key: string,
  private_key: string,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantWalletFeatureInitial(
        client_id,
        public_key,
        private_key
      );

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Wallet Feature enabled, New keys saved');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const revokeWalletFeatureAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.RevokeWalletFeature(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Wallet Feature disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const grantUseOfThirdPartyApisAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantUseOfThirdPartyApis(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Use of third party api enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const revokeUseOfThirdPartyApisAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.RevokeUseOfThirdPartyApis(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Use of third party apis disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const enableLogoAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.EnableLogo(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Tracking Logo enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const disableLogoAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.DisableLogo(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Tracking Logo disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const enableRatingsAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.EnableRatings(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Ratings enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const disableRatingsAction = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.DisableRatings(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Ratings disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const enableReceiveAllDriverLocation = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.EnableReceiveAllDriverLocation(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'All driver location updates enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const disableReceiveAllDriverLocation = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.DisableReceiveAllDriverLocation(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'All driver location updates disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const getPartners = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: PARTNERS_LOAD_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GetPartners();

      dispatch({ type: PARTNERS_LOAD_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: PARTNERS_LOAD_FAILURE, error });
    }
  };
};

export const addClientPartnerAction = (client_id: string, partners: []) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.AddClientPartner(client_id, partners);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
    } catch (error) {
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};

export const deleteClientPartnerAction = (client_id: string, partner: object) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: CLIENT_LOAD_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.DeleteClientPartner(client_id, partner);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
    } catch (error) {
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};

export const grantClientCustomFieldsPermissionsAction = (
  client_id: string,
  allow_custom_fields: boolean,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantClientCustomPaymentFields(
        client_id,
        allow_custom_fields
      );

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });

      props.closeBackdrop();
      if (allow_custom_fields) {
        props.showSnackbar('success', 'Allow custom fields enabled');
      } else {
        props.showSnackbar('success', 'Allow custom fields disabled');
      }
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};

export const grantGoogleMapsApiAction = (
  client_id: string,
  google_maps_api: boolean,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantGoogleMapsApi(client_id, google_maps_api);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });

      props.closeBackdrop();
      if (google_maps_api) {
        props.showSnackbar('success', 'Google Maps API enabled');
      } else {
        props.showSnackbar('success', 'Google Maps API disabled');
      }
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};

export const grantSmsNotifications = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantSmsNotifications(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Customer SMS Notifications enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const revokeSmsNotifications = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.RevokeSmsNotifications(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Customer SMS Notifications disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const grantEmailNotifications = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantEmailNotifications(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Customer Email Notifications enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const grantCustomerDetailsDatabase = (
  client_id: string,
  customer_details_database: boolean,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantCustomerDatabase(
        client_id,
        customer_details_database
      );

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar(
        'success',
        `Customer Database ${customer_details_database ? 'enabled' : 'disabled'}`
      );
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occurred!');
    }
  };
};
export const grantDeliveryMap = (client_id: string, delivery_map_enabled: boolean, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);
      const result = await clientUsecase.GrantDeliveryMap(client_id, delivery_map_enabled);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar(
        'success',
        `Driver App - Route on Map ${delivery_map_enabled ? 'enabled' : 'disabled'}`
      );
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occurred!');
    }
  };
};

export const grantAppChatBotAction = (client_id: string, enabled: boolean, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);
      const result = await clientUsecase.GrantAppChatBot(client_id, enabled);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar(`success', 'App Chat Bot ${enabled ? 'granted' : 'revoked'}`);
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'Error occurred!');
    }
  };
};

export const revokeEmailNotifications = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.RevokeEmailNotifications(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Customer Email Notifications disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const grantRoutePlanningAction = (
  client_id: string,
  route_planning_enabled: boolean,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantRoutePlanning(client_id, route_planning_enabled);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });

      props.closeBackdrop();
      if (route_planning_enabled) {
        props.showSnackbar('success', 'Route Planing enabled');
      } else {
        props.showSnackbar('success', 'Route Planning disabled');
      }
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};
export const enableSmsNotifications = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: SMS_NOTIFICATIONS_ENABLE_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantSmsNotifications(client_id);
      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
      props.closeLoader();
      props.showSnackbar('success', 'SMS Notifications enabled successfully');
    } catch (error) {
      props.closeLoader();
      props.showSnackbar('error', 'Error enabling SMS notifications');
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};

export const disableSmsNotifications = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: SMS_NOTIFICATIONS_DISABLE_REQUEST });

    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.RevokeSmsNotifications(client_id);
      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
      props.closeLoader();
      props.showSnackbar('success', 'SMS Notifications disabled successfully');
    } catch (error) {
      props.closeLoader();
      props.showSnackbar('error', 'Error disabling SMS notifications');
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};

export const enableOtpNotifications = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: OTP_SMS_NOTIFICATIONS_ENABLE_REQUEST });
    dispatch({ type: LOADING_REQUEST });
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantOtpSmsNotifications(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
      props.closeLoader();
      props.showSnackbar('success', 'OTP Notifications enabled successfully');
    } catch (error) {
      dispatch({ type: LOADING_FAILURE, error });
      props.closeLoader();
      props.showSnackbar('error', 'Error enabling OTP notifications');
    }
  };
};

export const disableOtpNotifications = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: OTP_SMS_NOTIFICATIONS_DISABLE_REQUEST });
    dispatch({ type: LOADING_REQUEST });
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.RevokeOtpSmsNotifications(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
      props.closeLoader();
      props.showSnackbar('success', 'OTP Notifications disabled successfully');
    } catch (error) {
      dispatch({ type: LOADING_FAILURE, error });
      props.closeLoader();
      props.showSnackbar('error', 'Error disabling OTP notifications');
    }
  };
};

export const updateSmsProviderAction = (
  client_id: string,
  smsProvider: string,
  apiKey1: string,
  apiKey2: string,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: SMS_PROVIDER_UPDATE_REQUEST });

    try {
      props.startLoader();
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.UpdateSmsProvider(
        client_id,
        smsProvider,
        apiKey1,
        apiKey2 || ''
      );
      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
      props.closeLoader();
      props.showSnackbar('success', 'SMS Provider and API keys updated successfully');
    } catch (error) {
      props.closeLoader();
      props.showSnackbar('error', 'Error updating SMS provider and API keys');
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};

export const editTakelotIntegration = (client_id: string, enabled: boolean, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.EditTakealotIntegration(client_id, enabled);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', `Takealot Integration ${enabled ? 'enabled' : 'disabled'}`);
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occurred!');
    }
  };
};

export const editPersistDriverLocation = (client_id: string, enabled: boolean, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.EditPersistDriverLocation(client_id, enabled);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', `Persist Driver Location ${enabled ? 'enabled' : 'disabled'}`);
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occurred!');
    }
  };
};

export const grantFlightboard = (client_id: string, enabled: boolean, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.GrantFlightboardAccess(client_id, enabled);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', `Flightboard ${enabled ? 'enabled' : 'disabled'}`);
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occurred!');
    }
  };
};

export const enableHubLevelClustering = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.EnableHubLevelClustering(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Hub level clustering enabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const disableHubLevelClustering = (client_id: string, props: any) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.DisableHubLevelClustering(client_id);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });
      props.closeBackdrop();
      props.showSnackbar('success', 'Hub level clustering disabled');
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occured!');
    }
  };
};

export const editRouteOptimizationAction = (
  client_id: string,
  return_geometry: boolean,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    try {
      const clientRepository = new ClientRepositoryImpl();
      const clientUsecase = new ClientUsecaseImpl(clientRepository);

      const result = await clientUsecase.EditRouteOptimization(client_id, return_geometry);

      dispatch({ type: CLIENT_LOAD_SUCCESS, payload: result });

      props.closeBackdrop();
      if (return_geometry) {
        props.showSnackbar('success', 'Route Geometry enabled');
      } else {
        props.showSnackbar('success', 'Route Geometry disabled');
      }
    } catch (error) {
      props.closeBackdrop();
      props.showSnackbar('error', 'error occurred!');
      dispatch({ type: CLIENT_LOAD_FAILURE, error });
    }
  };
};
